var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFacebookIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33342 9.00004H11.0001L11.6667 6.33337H9.33342V5.00004C9.33342 4.31337 9.33342 3.66671 10.6667 3.66671H11.6667V1.42671C11.4494 1.39804 10.6287 1.33337 9.76208 1.33337C7.95208 1.33337 6.66675 2.43804 6.66675 4.46671V6.33337H4.66675V9.00004H6.66675V14.6667H9.33342V9.00004Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFacebookIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/facebook-icon.9582566d55fd7d62d18721b057b61fc6.svg";